import { BehaviorSubject, Observable } from "rxjs";

export enum PanelManageActionsEnum {
  GRID = 'grid',
  CREATE = 'create',
  SEARCH = 'search',
  EDIT = 'edit',
  EDITSCHEDLUE = 'editschedlue',
  DETAIL = 'detail',
  ZONE = 'add-zone',
  ADDPHOTO = 'add-photo',
}

export enum CardActionEnum {
  EDIT = 'edit',
  DETAIL = 'detail',
  DELETE = 'delete',
  ZONE = 'add-zone',
  SUBPANEL = 'subpanel',
}

export enum PanelInfoSituationEnum {
  ABIERTO = 'Abierto',
  CERRADO = 'Cerrado',
  PROGRAMADO = 'Programado',
}


export abstract class PanelManagementDataSource<T = any> {
  protected filterSubject: BehaviorSubject<any>;
  protected panelDataSubject: BehaviorSubject<T>;
  protected subpanelSubject: BehaviorSubject<{ component: any; data: any }>;

  abstract setFilterState(formFilter: any): void;
  abstract setPanelData(data: T): void;
  abstract get filter$(): Observable<any>;
  abstract get panelData$(): Observable<T>;
  abstract get currentFilterState(): any;
  abstract get currentPanelData(): T;
  abstract get subpanel$(): Observable<{ component: any; data: any }>;
  abstract setSubpanel(data: { component?: any; data?: any }): void;
  abstract get currentSubpanel(): { component: any; data: any };
}